
import { CheckCircle } from "lucide-react";

interface ProgressStepsProps {
  currentStep: number;
}

export function ProgressSteps({ currentStep }: ProgressStepsProps) {
  const steps = [
    { number: 1, label: "Select Provider" },
    { number: 2, label: "Choose Date & Time" },
    { number: 3, label: "Patient Information" }
  ];

  return (
    <div className="flex items-center justify-center space-x-8">
      {steps.map((step, index) => (
        <div key={step.number} className="flex items-center">
          <div
            className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium transition-colors ${
              step.number <= currentStep
                ? "bg-blue-600 text-white"
                : "bg-gray-200 text-gray-600"
            }`}
          >
            {step.number < currentStep ? <CheckCircle className="w-4 h-4" /> : step.number}
          </div>
          <span className="ml-2 text-sm font-medium text-gray-600">
            {step.label}
          </span>
          {index < steps.length - 1 && <div className="w-16 h-px bg-gray-300 ml-4" />}
        </div>
      ))}
    </div>
  );
}
